import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type EmMachine } from "@packsize/schemas/machines";

import { getEmMachines } from "@/api/machines/em-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { EM_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getEmMachinesQuery = <TData = EmMachine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: EM_MACHINES_QUERY_KEY,
	queryFn: getEmMachines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useEmMachines = (
	options?: UseMachinesQueryOptions<EmMachine[], Error>,
): UseQueryResult<EmMachine[], Error> => {
	return useQuery<EmMachine[], Error>(getEmMachinesQuery(options));
};
